import api from './api';

export const getCases = async (params) => {
  const response = await api.get('/cases', { params });
  return response.data;
};

export const getCaseById = async (id) => {
  const response = await api.get(`/cases/${id}`);
  return response.data;
};

export const createCase = async (data) => {
  const response = await api.post('/cases', data);
  return response.data;
};

/**
 * FIXED: Added missing updateCase function 
 * requested by CaseForm.jsx
 */
export const updateCase = async (id, data) => {
  const response = await api.put(`/cases/${id}`, data);
  return response.data;
};

export const approveCaseLocal = async (id) => {
  const response = await api.post(`/cases/${id}/approve-local`);
  return response.data;
};

export const approveCaseMonthly = async (id) => {
  const response = await api.post(`/cases/${id}/approve-monthly`);
  return response.data;
};

export const approveCaseOrg = async (id) => {
  const response = await api.post(`/cases/${id}/approve-org`);
  return response.data;
};

export const closeCase = async (id) => {
  const response = await api.post(`/cases/${id}/close`);
  return response.data;
};
export const initiateContribution = async (caseId, amount) => {
  const response = await api.post(`/cases/${caseId}/contribute`, { amount });
  return response.data;
};

export const uploadCaseDocuments = async (caseId, files) => {
  const formData = new FormData();
  files.forEach(file => formData.append('documents', file));
  const response = await api.post(`/cases/${caseId}/documents`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });
  return response.data;
};
export const createMemberCase = async (data) => {
  const response = await api.post('/cases/member/create', data);
  return response.data;
};